module.exports = __webpack_public_path__ + "img/ic-id-active.8a0a83ab.svg";